import PropTypes from 'prop-types';

import { Image } from 'nordic/image';

import { UI_STYLE_PREFIX } from '../../constants/appConstants';

const React = require('react');

const HeaderComponent = ({ title, description, device, siteId }) => {
  const namespace = `${UI_STYLE_PREFIX}-title`;

  const altText =
    siteId === 'MLB' ? 'Blog MercadoLivre' : 'Blog de MercadoLibre';

  return (
    <div className={`${namespace}`}>
      <Image
        alt={altText}
        className={`${namespace}-image`}
        src={`meliblog-banner-${device}-v1.svg`}
      />

      <div
        className={`${namespace}-main-header-container ${device}`}
        data-testid="main-header-container"
      >
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    </div>
  );
};

HeaderComponent.propTypes = {
  siteId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  device: PropTypes.string.isRequired,
};

export default HeaderComponent;
